.content_layout {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  flex-direction: row;
  background-color: var(--bgBase);
}

.icon {
  width: 30px;
  height: 30px;
  vertical-align: middle !important;
  transition: all 0.3s ease;
}

.ant-menu-item:hover .icon,
.ant-menu-submenu-title:hover .icon {
  border-radius: 50%;
}

.ant-menu-horizontal {
  border-bottom: none;
}

.sidebar_main {
  border-left: 5px solid #ebebeb !important;
  transition: width 0.3s ease-in-out;
  flex: 0 0 300px !important;
  max-width: 300px !important;
  min-width: 307px !important;
  width: 300px !important;
}

.ant_layout_header {
  height: inherit;
  line-height: 3.5rem !important;
}

ul.ant-menu li.ant-menu-submenu .ant-menu-title-content {
  display: none;
}

.draggable_widget {
  pointer-events: auto;
  padding: 10px;
  border: 1px solid var(--borderColor, #ebebeb);
  border-radius: 8px;
  background: var(--floatingToolbarBgColor, white);
  position: absolute;
  z-index: 9999;
  box-shadow: 2px 2px 4px var(--shadowDim);
}

.drag_handle {
  color: var(--iconLineColor);
}

.divider {
  font-size: 11px;
}

.box {
  position: absolute;
  cursor: move;
  color: black;
  max-width: 215px;
  border-radius: 5px;
  padding: 1em;
  margin: auto;
  user-select: none;
}

.opacity_option_wrapper {
  align-content: center;
  justify-content: start;
  gap: 6px;
}

/* ============================================================================
   Property Panel Grid Layout with Subgrid
   - Parent grid defines shared column structure (label | value)
   - Child rows use subgrid to inherit column widths
   - Labels auto-size to the longest one across all rows
   ============================================================================ */
.property_grid {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 20px;
  column-gap: 8px;
  align-items: center;
}

/* Each property row spans both columns and uses subgrid */
.property_row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: span 2;
  align-items: center;
}

/* Property label - auto width based on content */
.property_label {
  white-space: nowrap;
  min-width: 3rem;
}

/* Property value container */
.property_value {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom_modal {
  width: 538px;
}

.resize_line {
  position: absolute;
  left: 0;
  cursor: row-resize;
  z-index: 10;
  background: #aaa;
  height: 1px;
  transition:
    background-color 0.2s ease,
    height 0.2s ease;
}

.resize_line::before {
  content: '';
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  height: 6px;
  background: transparent;
  pointer-events: auto;
}

.resize_line:hover {
  background: rgba(137, 207, 240, 0.5);
  height: 4px;
}

.resize_line.dragging {
  background: rgba(137, 207, 240, 0.7);
  height: 4px;
}

.delete_toggle {
  position: fixed;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
  border-radius: 4px;
  z-index: 9999;
  padding: 4px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  user-select: none;
  transition: background-color 0.2s ease;
}

.delete_toggle:hover {
  background: #f0f0f0;
}

.colorbox_wrapper {
  position: relative;
  display: inline-block;
}

.colorbox_selected_overlay {
  position: absolute;
  top: -3px;
  left: -3px;
  width: 100%;
  height: 100%;
  padding: 1.2px;
  border-radius: 6px;
  box-sizing: initial;
  border: 2px solid rgba(0, 0, 0, 1);
  /* visible border color */
  transition: border-color 0.35s ease;
  pointer-events: none;
  /* allow clicks through */
  content: '';
  /* no effect here but no harm */
}

.colorbox_hover_overlay :hover {
  position: absolute;
  top: -3px;
  left: -3px;
  width: 100%;
  height: 100%;
  padding: 1.2px;
  border-radius: 6px;
  box-sizing: initial;
  border: 2px solid rgb(143, 141, 141);
  /* visible border color */
  transition: border-color 0.35s ease;
  pointer-events: none;
  /* allow clicks through */
  content: '';
  /* no effect here but no harm */
}

.sliderColorPicker {
  width: 130px;
  height: 10px;
  border-radius: 5px;
  border: 1px solid #808080;
  margin: 8px 0 0 0;
}

.checker::before {
  content: '';
  background-image: linear-gradient(to right,
      rgba(var(--slider-r), var(--slider-g), var(--slider-b), 0) 0%,
      rgba(var(--slider-r), var(--slider-g), var(--slider-b), 1) 100%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.checker {
  background-color: #ffffff;

  /* overlap two 45 degree gradients to create a checker pattern */
  background-image:
    linear-gradient(45deg, #e6e6e6 25%, transparent 25%, transparent 75%, #e6e6e6 75%, #e6e6e6 100%),
    linear-gradient(45deg, #e6e6e6 25%, transparent 25%, transparent 75%, #e6e6e6 75%, #e6e6e6 100%);
  background-size: 8px 8px;
  background-position:
    0 0,
    calc(8px / 2) calc(8px / 2);

  /* if needed, repeat and position correction (sufficient by default) */
  background-repeat: repeat;
}

/* ============================================================================
   Toolbar Styles (Button-based Toolbar)
   ============================================================================ */

/* Toolbar container */
.shapeToolbar {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-right: 1px solid var(--borderColor);
}

/* SVG icons in toolbar buttons */
.shapeToolbar :global(.ant-btn) svg {
  color: var(--iconLineColor) !important;
  width: 1.8rem !important;
  height: 1.8rem !important;
}

/* Button sizing */
.shapeToolbar :global(.ant-btn) {
  min-width: 40px;
  height: 40px;
  margin-inline: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Space.Compact button group */
.shapeToolbar :global(.ant-space-compact) {
  display: flex !important;
}

/* Icon button in compact group */
.shapeToolbar :global(.ant-space-compact)> :global(.ant-btn):first-child {
  flex: 1;
  border-radius: 0.5rem;
}

/* Arrow button in compact group */
.shapeToolbar :global(.ant-space-compact)> :global(.ant-btn):last-child {
  min-width: 24px;
  padding: 0 4px;
}

/* trigger arrow for dropdown */
.shapeToolbar :global(.ant-dropdown-trigger) {
  padding: 1 !important;
  min-width: 0 !important;
  width: fit-content !important;
  visibility: hidden;
  position: absolute;
  right: -8px;
  z-index: 100;
}

/* Space.Compact button group */
.shapeToolbar :global(.ant-space-compact):hover :global(.ant-dropdown-trigger) {
  visibility: visible;
}

/* Shape List View 버튼 — 눌려진 상태 스타일 (engview/form.css .check-button[data-value='true'] 참조) */
.shapeListViewButton[data-value='true']:not([disabled]) {
  background-color: var(--primaryColor);
  color: var(--accentColor) !important;
}

/* Dropdown menu items */
.shapeMenu :global(.ant-dropdown-menu-item) {
  display: flex !important;
  gap: 0.5rem !important;
  align-items: center;
  justify-content: start;
  padding-inline: 1rem !important;
}

/* SVG icons in dropdown menu */
.shapeMenu :global(.ant-dropdown-menu-item) svg {
  color: var(--iconLineColor) !important;
  width: 1.8rem !important;
  height: 1.8rem !important;
}

/* ============================================================================
   Shape List view Styles
   ============================================================================ */
/* Shape row height */
.table_list_wrapper :global(.ant-table-tbody)>tr>td {
  padding: 0.5rem 0.5rem;
  height: 1rem;
}

/* indicator header row: no hover, smaller height, left aligned */
.indicatorHeaderRow {
  cursor: default !important;
  padding: 0% !important;
}

/* override Ant hover for header rows */
.indicatorHeaderRow td,
.indicatorHeaderRow:hover td {
  background-color: color-mix(in srgb, var(--buttonColor) 50%, var(--bgBase)) !important;
}

/* make header cells left-aligned and reduce vertical padding for smaller row height */
.indicatorHeaderRow>td {
  text-align: left !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  height: 28px;
  /* you can tune this */
}

/* Shape row flex container */
.shapeRow {
  margin-left: 1rem;
  display: flex;
  align-items: center;
}

/* Shape label container (icon + text) */
.shapeLabel {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  /* Allow shrinking below content size */
  gap: 10px;
}

/* Shape label text with ellipsis */
.shapeLabelText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Action buttons container - hidden by default */
.shapeActions {
  display: flex;
  flex-shrink: 0;
  opacity: 0;
  pointer-events: none;
  margin-left: 8px;
  position: absolute;
  right: 0.5rem;
}

.selectedRow,
.selectedRow:hover,
.selectedRow:hover>td {
  background-color: color-mix(in srgb, var(--accentColor, #1890ff) 20%, var(--buttonColor)) !important;
}

/* Show action buttons on row hover */
.table_list_wrapper :global(.ant-table-tbody)>tr:hover .shapeActions {
  opacity: 1;
  pointer-events: auto;
}

/* Hide AntD Table's built-in scrollbar (use wrapper's scrollbar instead) */
.table_list_wrapper :global(.ant-table-content) {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.table_list_wrapper :global(.ant-table-content)::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Edge */
}

.iconBtn {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 4px;
  /* small clickable area */
  color: rgba(0, 0, 0, 0.45);
  transition: all 0.2s ease;
}

.iconBtn:hover {
  background: rgba(0, 0, 0, 0.04) !important;
  color: rgba(0, 0, 0, 0.75);
}

.iconBtn:focus,
.iconBtn:active {
  background: transparent !important;
  box-shadow: none !important;
}

.locked {
  color: #000;
}
